import React, { Component } from 'react';
import Image from 'next/image';
import {
  message,
  List,
  Row,
  Col,
  Modal,
  Form,
  Input,
  Button,
  Radio,
  Space,
} from 'antd';
import { Player, ControlBar, BigPlayButton } from 'video-react';
import reserveApi from '../../api/reserveApi';
import { timerFormat } from '../../utils/utils';

import defaultImg from '../../public/images/hidream-admin-bg.jpg';

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: '请填写${label}!',
  types: {
    email: '请填写有效${label}!',
  },
};
/* eslint-enable no-template-curly-in-string */

export class ArticleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFormVisible: false,
      isCodeVisible: false,
      isReserved: false,
      delModelVisible: [],
      currentVideoSrc: {},
    };
  }

  showModal = () => {
    this.setState({
      isFormVisible: true,
      isCodeVisible: false,
      isReserved: false,
    });
  };

  handleCancel = () => {
    this.setState({
      isFormVisible: false,
      isCodeVisible: false,
      isReserved: false,
    });
  };

  showVideoModal = (item) => {
    const delModelVisible = this.state.delModelVisible;
    delModelVisible[item.title] = true;

    this.setState({
      delModelVisible,
      currentVideoSrc: item.videoSrc,
    });
  };

  handleVideoCancel = () => {
    setTimeout(() => {
      this.setState({
        delModelVisible: [],
      });
    });
  };

  onFinish = (values) => {
    let data = { ...values, live_id: 1 };

    reserveApi(data).then((res) => {
      if (res.status === 200) {
        this.setState({
          isReserved: true,
        });
        message.success('已提交预约，请扫描二维码，谢谢。');

        setTimeout(() => {
          this.setState({
            isCodeVisible: true,
          });
        }, 1000);
      } else {
        this.setState({
          isFormVisible: false,
        });

        let error_msgs = '',
          msgs = res.data.msg;
        if (typeof msgs == 'object') {
          Object.keys(msgs).forEach((key) => {
            return (error_msgs += `${msgs[key]};`);
          });
        } else {
          error_msgs = msgs;
        }
        message.error(error_msgs, 1);
        message.success('2秒后展示预约二维码', 2);

        setTimeout(() => {
          if (msgs.telephone) {
            this.setState({
              isFormVisible: false,
              isCodeVisible: true,
              isReserved: true,
            });
          }
        }, 3000);
      }
    });
  };

  render() {
    const {
      isFormVisible,
      isCodeVisible,
      delModelVisible,
      isReserved,
      currentVideoSrc,
    } = this.state;
    const { videoData } = this.props;

    videoData.forEach((item) => {
      item.videoSrc = {
        poster: item.src
          ? `https://cdn-storage.hidream.net/${item.src}`
          : defaultImg,
        src: item.video_url,
      };
    });

    return (
      <List
        className="videoList"
        itemLayout="vertical"
        pagination={false}
        dataSource={videoData}
        renderItem={(item) => (
          <List.Item key={item.title} className="listItem">
            <div className="listImg">
              <Image
                src={
                  item.src
                    ? `https://cdn-storage.hidream.net/${item.src}`
                    : defaultImg
                }
                alt={item.title}
                onClick={() => {
                  item.is_reserve
                    ? this.showModal(item)
                    : this.showVideoModal(item);
                }}
                width={750}
                height={442}
              />
              {item.is_reserve ? (
                <div className="listTag">
                  <Image
                    src={require('../../public/images/预约中@2x.png').default}
                    alt="直播-预约中"
                    onClick={this.showModal}
                  />

                  {!isReserved ? (
                    <Modal
                      title="填写报名信息"
                      visible={isFormVisible}
                      onCancel={this.handleCancel}
                      destroyOnClose
                      maskClosable={true}
                      footer={null}
                    >
                      <Form
                        name="reserveForm"
                        layout="vertical"
                        onFinish={this.onFinish}
                        validateMessages={validateMessages}
                      >
                        <Form.Item
                          name="name"
                          label="姓名"
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="telephone"
                          label="手机"
                          rules={[
                            { required: true },
                            {
                              pattern: /^1[345789]\d{9}$/,
                              message: '请输入正确的手机格式',
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="company"
                          label="公司"
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="company_type"
                          label="公司类型"
                          placeholder="请选择"
                          rules={[{ required: true }]}
                        >
                          <Radio.Group>
                            <Space direction="vertical">
                              <Radio value="品牌型企业">品牌型企业</Radio>
                              <Radio value="工厂型企业">工厂型企业</Radio>
                              <Radio value="贸易型企业">贸易型企业</Radio>
                            </Space>
                          </Radio.Group>
                        </Form.Item>
                        <Form.Item name="brand" label="品牌名称(选填)">
                          <Input />
                        </Form.Item>
                        <Form.Item name="job_title" label="职位">
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="inviter"
                          label="邀请人(若无，则填“无”)(选填)"
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item>
                          <Button type="primary" htmlType="submit">
                            提交
                          </Button>
                        </Form.Item>
                      </Form>
                    </Modal>
                  ) : (
                    <Modal
                      title="直播预约二维码"
                      visible={isCodeVisible}
                      onCancel={this.handleCancel}
                      destroyOnClose
                      maskClosable={true}
                      footer={null}
                      className="videoModal"
                      centered
                    >
                      <Image
                        src={
                          item.reserve_src
                            ? `https://cdn-storage.hidream.net/${item.reserve_src}`
                            : ''
                        }
                        alt="直播二维码"
                      />
                    </Modal>
                  )}
                </div>
              ) : (
                <div className="listTag">
                  <Image
                    src={require('../../public/images/可回放@2x.png').default}
                    alt="直播-可回放"
                    onClick={() => {
                      this.showVideoModal(item);
                    }}
                  />
                  {delModelVisible[item.title] ? (
                    <Modal
                      title="直播回放"
                      visible={delModelVisible[item.title]}
                      onCancel={this.handleVideoCancel}
                      destroyOnClose
                      maskClosable={true}
                      footer={null}
                      className="videoModal"
                      centered
                    >
                      <Player
                        playsInline
                        poster={currentVideoSrc.poster}
                        src={currentVideoSrc.src}
                      >
                        <ControlBar
                          autoHide={false}
                          disableDefaultControls={false}
                        />
                        <BigPlayButton position="center" />
                      </Player>
                    </Modal>
                  ) : null}
                </div>
              )}
            </div>

            <div className="listContent">
              <div
                className="header"
                onClick={() => {
                  item.is_reserve
                    ? this.showModal(item)
                    : this.showVideoModal(item);
                }}
              >
                <div className="title">{item.title}</div>
                <p className="description">
                  {item.description ? item.description : ''}
                </p>
              </div>

              <Row justify="space-between" align="middle">
                <Col className="origin">
                  <div className="img">
                    <Image
                      src={require('../../public/images/hi.png').default}
                      alt="Hidream"
                    />
                  </div>
                  讯梦国际
                </Col>
                <Col className="time">
                  {item.updated_at
                    ? timerFormat(item.updated_at)
                    : item.updated_at}
                </Col>
              </Row>
            </div>
          </List.Item>
        )}
      />
    );
  }
}

export default ArticleList;
